import React from "react";
import { IconProps } from "types/v2/common/IconProps";
import classes from "./SupportIcon.module.scss";

const SupportIcon: React.FC<IconProps> = ({ active }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0C5.3832 0 0 5.3832 0 12V16.9716C0 18.2004 1.0764 19.2 2.4 19.2H3.6C3.91826 19.2 4.22348 19.0736 4.44853 18.8485C4.67357 18.6235 4.8 18.3183 4.8 18V11.8284C4.8 11.5101 4.67357 11.2049 4.44853 10.9799C4.22348 10.7548 3.91826 10.6284 3.6 10.6284H2.5104C3.1776 5.9844 7.1736 2.4 12 2.4C16.8264 2.4 20.8224 5.9844 21.4896 10.6284H20.4C20.0817 10.6284 19.7765 10.7548 19.5515 10.9799C19.3264 11.2049 19.2 11.5101 19.2 11.8284V19.2C19.2 20.5236 18.1236 21.6 16.8 21.6H14.4V20.4H9.6V24H16.8C19.4472 24 21.6 21.8472 21.6 19.2C22.9236 19.2 24 18.2004 24 16.9716V12C24 5.3832 18.6168 0 12 0Z"
        className={
          active
            ? classes["support-icon-path-active"]
            : classes["support-icon-path"]
        }
      />
    </svg>
  );
};

export default SupportIcon;
